import { Stack, styled } from '@mui/material';

export const ButtonWrapper = styled(Stack)`
  gap: 8px;
  padding-top: 16px;
  flex-direction: row;
  justify-content: flex-end;
`;
